import Component from "vue-class-component";
import Vue from "vue";

@Component({ name: "WithFirstLoad" })
export default class WithFirstLoad extends Vue {
  public firstLoad: boolean = true;

  public setFirstLoad() {
    this.firstLoad = false;
  }
}
